import { ContentWrapper } from '@/components/_common';
import { TransactionType } from '@/core/domain/financial/BankConciliation/BankConciliation.types';
import { useBankConciliationContext } from '@/pages/FinancialPages/BankConciliationPage';
import { Col, Empty, Row, Typography } from 'antd';
import BankConciliationAccountReceivableList from './BankConciliationAccountReceivableList';
import BankConciliationAccountPayableList from './BankConciliationAccountPayableList';

export enum Account {
  correspondingAccount = 'CORRESPONDING_ACCOUNT',
  account = 'ACCOUNT',
}

export default function BankConciliationAccountsCard() {
  const { transactionSelected } = useBankConciliationContext();

  if (!transactionSelected) {
    return (
      <ContentWrapper width="100%" style={{ padding: 12 }}>
        <Empty description="Selecione uma transação" />
      </ContentWrapper>
    );
  }

  const selectedTransactionType = transactionSelected.type;

  const isReceivable = selectedTransactionType === TransactionType.credit;
  const isPayable = selectedTransactionType === TransactionType.debit;

  const getTitle = () => {
    if (isReceivable) {
      return 'Contas a receber';
    }
    if (isPayable) {
      return 'Contas a pagar';
    }
    return 'Contas';
  };

  return (
    <ContentWrapper width="100%" style={{ padding: 12 }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Typography.Title level={5}>{getTitle()}</Typography.Title>
        </Col>

        <Col span={24}>
          {isReceivable && <BankConciliationAccountReceivableList />}

          {isPayable && <BankConciliationAccountPayableList />}

          {!isReceivable && !isPayable && (
            <Empty description="Tipo de transação não suportado" />
          )}
        </Col>
      </Row>
    </ContentWrapper>
  );
}
